<template>
  <div
    class="podcast-links d-flex flex-row justify-content-center align-items-center flex-wrap py-3 c-charcoal"
  >
    <a
      v-for="icon in visibleIcons"
      :key="icon.name"
      :href="icon.url"
      @click="icon.action"
      _target="blank"
      class="undecorated-router-link"
    >
      <img
        :src="icon.icon"
        class="mr-3 podcast-icon"
        :class="`${icon.additionalCss}`"
        v-tooltip="{
          content: icon.name,
          delay: 100,
          placement: 'top',
          container: 'body',
        }"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'PodcastLinkIcons',
  props: {
    podcast: {
      type: Object,
    },
  },
  computed: {
    visibleIcons() {
      return this.icons.filter(icon => icon.visible);
    },
    icons() {
      return [
        {
          name: 'iTunes',
          icon: '/assets/images/itunes.svg',
          url: this.itunesFeed,
          additionalCss: 'itunes mr-2',
          action: () => {},
          visible: ['mac', 'windows'].indexOf(this.os) > -1,
        },
        {
          name: 'Apple Podcasts',
          icon: '/assets/images/apple-podcasts.svg',
          url: this.applePodcastsFeed,
          action: () => {},
          visible: ['ios', 'catalina', 'bigsur'].indexOf(this.os) > -1,
        },
        {
          name: 'Overcast',
          icon: '/assets/images/overcast.svg',
          url: this.overcastFeed,
          action: () => {},
          visible: ['ios'].indexOf(this.os) > -1,
        },
        {
          name: 'Podcast Addict',
          icon: '/assets/images/podcast-addict.svg',
          url: this.podcastAddictFeed,
          action: () => {},
          visible: ['android'].indexOf(this.os) > -1,
        },
        {
          name: 'Pocket Casts',
          icon: '/assets/images/pocket-casts.svg',
          url: this.pocketCastsFeed,
          action: () => {},
          visible: ['windows', 'android', 'ios'].indexOf(this.os) > -1,
        },
        {
          name: 'Downcast',
          icon: '/assets/images/downcast.svg',
          url: this.downcastFeed,
          action: () => {},
          visible: ['ios', 'mac', 'catalina', 'bigsur'].indexOf(this.os) > -1,
        },
        {
          name: this.$t('PODCASTS.LABELS.COPY_RSS_LINK'),
          icon: '/assets/images/rss-feed-url.svg',
          url: null,
          action: this.copyRSSLink,
          visible: true,
        },
      ];
    },
    os() {
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.platform;
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
      const applePlatforms = ['iPhone', 'iPad', 'iPod'];
      let operatingSystem = null;

      if (['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)) {
        operatingSystem = 'mac';
        if (/10_15|10.15/.test(userAgent)) {
          operatingSystem = 'catalina';
        }
        if (/11_|11./.test(userAgent)) {
          operatingSystem = 'bigsur';
        }
      } else if (applePlatforms.includes(platform)) {
        operatingSystem = 'ios';
      } else if (windowsPlatforms.includes(platform)) {
        operatingSystem = 'windows';
      } else if (/Android/.test(userAgent)) {
        operatingSystem = 'android';
      } else if (!operatingSystem && /Linux/.test(platform)) {
        operatingSystem = 'linux';
      }
      return operatingSystem;
    },
    itunesFeed() {
      const url = new URL(this.podcast.feed_url);
      return `itpc://${url.host}${url.pathname}`;
    },
    applePodcastsFeed() {
      const url = new URL(this.podcast.feed_url);
      return `podcast://${url.host}${url.pathname}`;
    },
    overcastFeed() {
      return `overcast://x-callback-url/add?url=${this.podcast.feed_url}`;
    },
    podcastAddictFeed() {
      const url = new URL(this.podcast.feed_url);
      return `podcastaddict://${url.host}${url.pathname}`;
    },
    pocketCastsFeed() {
      const url = new URL(this.podcast.feed_url);
      return `pktc://subscribe/${url.host}${url.pathname}`;
    },
    downcastFeed() {
      const url = new URL(this.podcast.feed_url);
      return `downcast://subscribe/${url.host}${url.pathname}`;
    },
  },
  methods: {
    copyRSSLink() {
      this.$copyText(this.podcast.feed_url).then(() => {
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t('NOTIFICATIONS.TEXT.LINK_COPIED_TO_CLIPBOARD'),
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.podcast-links {
  min-height: 72px;

  @include media-breakpoint-up(md) {
    border-left: 2px solid white;
  }
}

.podcast-icon {
  width: 36px;
  height: 36px;
}
</style>
